/**
 * checks if passed formGroup is invalid
 * ignoreFields is used to skip checking validity on provided nested form groups
 */
import { FormGroup, ValidatorFn } from '@angular/forms';

export function setValidatorsOnAllControlsInForm(form: FormGroup, validators: Array<ValidatorFn>, emitEvent = true): void {
  for (const controlsKey in form.controls) {
    form.get(controlsKey)?.setValidators(validators);
    form.get(controlsKey)?.updateValueAndValidity({ emitEvent });
  }
}

export function isFormGroupInvalidExcept(
  formGroup: FormGroup,
  ignoreFields: string[]
): boolean {

  return Object.keys(formGroup.controls).some(key => {
    if (ignoreFields.includes(key)) {
      return false;
    }

    const control = formGroup.get(key);
    return !!control && control.invalid;
  });
}